module.exports = __webpack_public_path__ + "img/user.d785c7d2.png";